import { SortDirection } from 'features/common'
import { MapFieldToOrderBy, MapOwnerFilter, MapListFilters } from './types'

export const DEFAULT_FILTERS: MapListFilters = {
  search: '',
  order: {
    by: MapFieldToOrderBy.UpdatedAt,
    direction: SortDirection.Desc
  },
  permissions: MapOwnerFilter.All
}
